import { array, string } from 'prop-types'
import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2'
import { showFeedInspection } from 'shared/application/services/linkInspection'
import { feedTitleKeys, formatDate, formatHour } from 'shared/helpers'
import { InspectionLink } from 'shared/ui/InspectionLink'
import {
  FEED_ITEM_REJECTION_DESCRIPTION,
  FEED_ITEM_TITLE,
} from '../../domain/constants'
import {
  Box,
  CustomScroll,
  Fade,
  FeedAction,
  FeedItem,
  FeedItemContent,
  FeedItemPulsingCircle,
  FeedItemRejectionReason,
  FeedItemSubtitle,
  FeedItemTime,
  FeedItemTitle,
  Title,
} from './Lead.styles'

const Feed = ({
  feedItems,
  mountFeedTitle,
  product,
  resolveFeedColor,
  handleDocumentRouterChange,
  setShowFade,
  showFade,
}) => {
  return (
    <Box>
      <Title variant="h4">Atualizações</Title>
      <Scrollbars
        autoHeight
        autoHeightMax={350}
        renderThumbVertical={() => <CustomScroll />}
        onUpdate={({ top, clientHeight }) => {
          if (top === 0 && clientHeight < 350) {
            setShowFade(false)
          } else if (top >= 0.9) {
            setShowFade(false)
          } else {
            setShowFade(true)
          }
        }}
      >
        {feedItems.map((item, index, feeds) => (
          <FeedItem data-testid={`feed-item-${index}`} key={item.id}>
            <FeedItemPulsingCircle
              variant={resolveFeedColor(item?.name, item?.doneAt)}
              size={6}
              animate={
                item?.name === feedTitleKeys.DOCUMENT_REQUIRED &&
                item?.doneAt === undefined
              }
            />
            <FeedItemContent>
              <FeedItemTitle data-testid={`feed-item-title-${index}`}>
                {mountFeedTitle(
                  FEED_ITEM_TITLE[item?.name]?.title,
                  item.description,
                )}
              </FeedItemTitle>
              {FEED_ITEM_TITLE[item?.name]?.subtitle && (
                <FeedItemSubtitle
                  data-testid={`feed-item-subtitle-${index}`}
                  dangerouslySetInnerHTML={{
                    __html: FEED_ITEM_TITLE[item?.name]?.subtitle,
                  }}
                />
              )}
              <FeedItemTime>{`${formatDate(item.createdAt)} às ${formatHour(
                item.createdAt,
              )}`}</FeedItemTime>
              {item.description && (
                <FeedItemRejectionReason
                  data-testid={`feed-item-desc-${index}`}
                >
                  {FEED_ITEM_REJECTION_DESCRIPTION[item.description] || null}
                </FeedItemRejectionReason>
              )}
              {!item.doneAt &&
                item.name === feedTitleKeys.DOCUMENT_REQUIRED && (
                  <FeedAction
                    onClick={() => handleDocumentRouterChange({ product })}
                  >
                    Enviar documentos
                  </FeedAction>
                )}
              {showFeedInspection({
                feeds,
                currentFeedName: item.name,
              }) && <InspectionLink />}
            </FeedItemContent>
          </FeedItem>
        ))}
      </Scrollbars>
      <Fade show={showFade} />
    </Box>
  )
}

Feed.propTypes = {
  feedItems: array,
  product: string,
}

export { Feed }
